import React, { useState } from 'react';
import { Button, Input } from '../../../../component';
import ReactQuill from 'react-quill';
import './bookingFlights.scss';

const OtherRequest = (props) => {
  const [subjectKey, setSubjectKey] = useState('');
  const [messageContent, setMessageContent] = useState('');
  return (
    <>
      <div>
        <div className="modal-body px-0">
          <div className="d-flex flex-column col-12 font-small">
            <Input
              type="text"
              name={`subjectKey`}
              value={subjectKey}
              label={props.intl.formatMessage({
                id: 'ticket.subject',
              })}
              themeMode="light"
              iconUrl={null}
              onChange={(event) => {
                const { value } = event.target;
                setSubjectKey(value);
              }}
              outSideLabelClass="text-start font-weight-bold"
              inputClassName={'text-start px-sm-3 px-3'}
              outSideLabelPosition="top"
              outSideLabel={true}
              boxColor={'bg-white shadow'}
            />
            <div className="default-border-radius-small mt-4">
              <ReactQuill
                name="myTextarea"
                id="myTextarea"
                className="pt-0 mt-0 default-border-radius-small  booking  text-dark shadow"
                style={{
                  backgroundColor: '#ffffff',
                  color: 'black',
                }}
                placeholder={props.intl.formatMessage({
                  id: 'ticket.description',
                })}
                value={messageContent}
                theme="snow"
                onChange={(event) => setMessageContent(event)}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer border-0  d-flex justify-content-center py-3 pb-0">
          <Button
            name={`sendProblem-bookingFlight`}
            id={`sendProblem-bookingFlight`}
            className="btn-secondary"
            label={props.intl.formatMessage({
              id: `ticket.send`,
            })}
            disabled={
              messageContent === '<p><br></p>' || !messageContent || !subjectKey
            }
            loading={props.loading}
            onClick={() => {
              props.handleSubmit({
                subjectKey,
                messageContent,
              });
            }}
          />
        </div>
      </div>
    </>
  );
};
export default OtherRequest;
